import { render, staticRenderFns } from "./LogoPlein.vue?vue&type=template&id=488633f1"
import script from "./LogoPlein.vue?vue&type=script&lang=js"
export * from "./LogoPlein.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports